// WebsiteEditPage.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Input from "@mui/material/Input";

import FormControl from "@mui/material/FormControl";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
export const WebsiteIndividualEdit = () => {
  const { websiteId } = useParams();
  const navigator = useNavigate();
  const [imageFile, setImageFile] = useState(null);
  const [avatarSrc, setAvatarSrc] = React.useState();
  const [imageAllowed, setImageAllowed] = useState(null);
  const [website, setWebsite] = useState({
    _id: "",
    page: "",
    key: "",
    value: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setAvatarSrc(URL.createObjectURL(file));
  };
  useEffect(() => {
    const getWebsite = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/blogs/hero/indi/${websiteId}`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (
          data.key === "Equitable" ||
          data.key === "Trust" ||
          data.key === "Relatability" ||
          data.key === "Identity"
        ) {
          setImageAllowed(true);
        } else {
          setImageAllowed(false);
        }
        setWebsite(data);
      } catch (error) {
        console.log(error);
      }
    };

    getWebsite();
  }, [websiteId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWebsite((prevWebsite) => ({
      ...prevWebsite,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(imageFile);
    try {
      const responce = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/hero/edit/${websiteId}`,
        {
          page: website.page,
          key: website.key,
          value: website.value,
          image: imageFile,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      // Redirect to the individual website page after editing
      console.log(responce);
      if (responce.data.message === "saved successfully") {
        navigator(`/website/${websiteId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (!website) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Typography variant="h4">Edit Hero Data</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Page"
          name="page"
          value={website.page}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Key"
          name="key"
          value={website.key}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Value"
          name="value"
          multiline
          rows={4}
          value={website.value}
          onChange={handleChange}
        />
        {imageAllowed && (
          <FormControl fullWidth margin="normal">
            {/* <InputLabel htmlFor="image">Image</InputLabel> */}
            <Input
              type="file"
              accept="image/*"
              id="image"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
            <label htmlFor="image">
              <Button
                variant="outlined"
                component="span"
                startIcon={<CloudUploadIcon />}
              >
                Upload Image
              </Button>
            </label>
            <img
              src={avatarSrc}
              style={{ width: "12vw", margin: "1.5rem 0px" }}
            />
          </FormControl>
        )}
        {/* Add more form fields based on your website schema */}
        <Button type="submit" variant="contained" color="primary">
          Save Changes
        </Button>
      </form>
    </div>
  );
};
